module.exports = __webpack_public_path__ + "static/media/project-reiki.b81dfc27.jpg";